export const REVIEW_OPEN = 1
export const REVIEW_COMPLETED = 2
export const REVIEW_CLOSED = 3

export const REVIEW_STATUS = [
    {
        status: REVIEW_OPEN,
        text: 'Open'
    }, 
    {
        status: REVIEW_COMPLETED,
        text: 'Complete'
    }, 
    {
        status: REVIEW_CLOSED,
        text: 'Close'
    }
]

export const COMPLIANCE_PENDING = 'Pending'
export const COMPLIANCE_YES = 'Yes'
export const COMPLIANCE_NO = 'No'



// WEBPACK FOOTER //
// ./src/components/complianceAudit/Constants.js